var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"content-load",class:{ 'full-loading': !_vm.template }},[_c('base-loading',{attrs:{"color":"var(--default)"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }